import { StylishNewCheckbox } from 'components/DesignSystems/New/StylishNewCheckbox';
import { IconButton } from 'components/DesignSystems/buttons/IconButton';
import { Layer } from './Layer';
import { EriLayerBody } from './OutageLayerBodies';
import { ERI_LAYER_TITLE, useEriLayerControls } from './useOutageLayerControls';

/**
 * Layers tab row for the county-level "Outage Prediction (ERI)" choropleth
 * (classic Bootstrap panel).
 */
export function EriLayerItem() {
  const controls = useEriLayerControls();

  return (
    <Layer.Item
      eventKey="eri-layer"
      header={
        <div className="d-flex justify-content-between align-items-center w-100">
          <div className="d-flex align-items-center gap-2">
            <StylishNewCheckbox
              className="mt-0"
              checked={controls.isVisible}
              onClick={(e) => {
                e.stopPropagation();
                controls.toggleVisibility();
              }}
            />
            <span className="fw-semibold">{ERI_LAYER_TITLE}</span>
          </div>
          <IconButton
            iconProps={{ iconName: 'map' }}
            onClick={(e) => {
              e.stopPropagation();
              controls.zoomToLayer();
            }}
            aria-label="Zoom to ERI forecast"
            title="Zoom to ERI forecast"
            disabled={controls.zoomDisabled}
          />
        </div>
      }
    >
      <Layer.Content>
        <EriLayerBody controls={controls} />
      </Layer.Content>
    </Layer.Item>
  );
}
